<section class="login_section">
    <!-- Full Page Intro -->
    <div class="view">
      <!-- Mask & flexbox options-->
      <div class="mask rgb-gradient d-flex justify-content-center align-items-center">
        <!-- Content -->
        <div class="container">
          <!--Grid row-->
          <!--Grid column-->
          <div class="col-lg-5 col-md-8 col-sm-9 ml-auto mr-auto">
            <!--Form-->
            <mdb-card class="wow fadeInRight p-1" data-wow-delay="0.3s">
              <mdb-card-body class="z-depth-2 p-4">
                  <div class="login__logo" style="margin:0 auto 2rem auto;">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/educational_documents/Miles%20Website%20Images/home/MilesEducation_Main_Logo.png" alt="Miles CPA LMS" style="width:300px; margin: auto;">
                    </a>
                    </div>
                  <!--Header-->
                  <div>
                    <div class="text-center">
                        <h3 class="dark-grey-text f-20 font-weight-bolder text-uppercase" style="color: #00c851 !important;">
                            <i class="fad fa-check-circle" aria-hidden="true"></i> Successfully Register!
                        </h3>
                        <p class="register_txt my-4" style="color: rgba(0, 0, 0, 0.5) !important;">We will send you OTP on +91 1234567894
                            <abbr title="attribute" class="text-primary">&nbsp;Edit&nbsp;<i class="fad fa-edit"></i></abbr>
                        </p>
                    </div>
                    <!--Body-->
                    <div class="btn-group d-flex justify-content-around mt-4 pl-xl-3 pl-lg-3 pl-sm-3 pl-0">
                        <button mdbBtn gradient="blue" mdbWavesEffect class="mr-xl-3 mr-lg-3 mr-sm-3 mr-0" style="width: 100px;">Verify OTP</button>
                        <button mdbBtn color="danger" mdbWavesEffect class="mr-xl-3 mr-lg-3 mr-sm-3 mr-0" style="width: 100px;" routerLink="">Cancel</button>
                    </div>
                  </div>

                  <div>
                    <div class="text-center">
                        <h3 class="dark-grey-text f-20 font-weight-bolder text-uppercase">
                            Verification Code
                        </h3>
                        <p class="register_txt my-4" style="color: rgba(0, 0, 0, 0.5) !important;">Please type the verification code sent to +91 1234567894</p>
                        <div class="otp d-flex">
                            <input type="password" id="defaultLoginFormPassword" class="form-control mb-4" >
                            <input type="password" id="defaultLoginFormPassword" class="form-control mb-4" >
                            <input type="password" id="defaultLoginFormPassword" class="form-control mb-4" >
                            <input type="password" id="defaultLoginFormPassword" class="form-control mb-4" >
                        </div>
                        <p class="register_txt mt-1" style="color: rgba(0, 0, 0, 0.5) !important;">If you didn't receive a code! <a class="text-black-50 f-15 text-center">Resend <i class="fad fa-sync"></i></a></p>
                    </div>
                    <!--Body-->
                    <div class="text-center">
                        <button mdbBtn gradient="blue" mdbWavesEffect routerLink="/successfully-register">Verify</button>
                    </div>
                  </div>

                  <div>
                    <div class="text-center">
                        <h3 class="dark-grey-text f-20 font-weight-bolder text-uppercase" style="color: #00c851 !important;">
                            <i class="fad fa-check-circle" aria-hidden="true"></i> Congratulations!
                        </h3>
                        <p class="register_txt my-4" style="color: rgba(0, 0, 0, 0.5) !important;">Mobile verifications has successfully done.</p>
                    </div>
                    <!--Body-->
                    <div class="text-center mt-4">
                        <button mdbBtn gradient="blue" mdbWavesEffect>Done</button>
                    </div>
                  </div>

                  <div>
                    <div class="text-center">
                        <h3 class="dark-grey-text f-20 font-weight-bolder text-uppercase" style="color: #ff3547 !important;">
                            <i class="fad fa-times-circle" aria-hidden="true"></i> Failed!
                        </h3>
                        <p class="register_txt my-4" style="color: rgba(0, 0, 0, 0.5) !important;">Mobile verifications has successfully done.</p>
                    </div>
                    <!--Body-->
                    <div class="btn-group d-flex justify-content-around mt-4 pl-xl-3 pl-lg-3 pl-sm-3 pl-0">
                        <button mdbBtn gradient="blue" mdbWavesEffect class="mr-xl-3 mr-lg-3 mr-sm-3 mr-0" style="width: 100px;">Edit</button>
                        <button mdbBtn color="danger" mdbWavesEffect class="mr-xl-3 mr-lg-3 mr-sm-3 mr-0" style="width: 100px;" routerLink="">Cancel</button>
                    </div>
                  </div>

                  <!-- <div>
                    <div class="text-center">
                        <h3 class="dark-grey-text f-20 font-weight-bolder text-uppercase">
                            Edit Contact Details
                        </h3>
                        <p class="register_txt my-4" style="color: rgba(0, 0, 0, 0.5) !important;">Mobile verifications has successfully done.</p>
                    </div>
                    <div class="md-form md-outline">
                        <mdb-icon fas icon="mobile" class="text-black-50"></mdb-icon>
                        <input type="text" id="inputIconEx1" class="form-control" mdbInput
                       >
                        <label for="inputIconEx1">Contact Number</label>
                      </div>
                    <div class="text-center mt-4">
                        <button mdbBtn gradient="blue" mdbWavesEffect>Submit</button>
                    </div>
                  </div> -->



              </mdb-card-body>
            </mdb-card>
            <!--/.Form-->
          </div>
          <!--Grid row-->
        </div>
        <!-- Content -->
      </div>
      <!-- Mask & flexbox options-->
    </div>
    <!-- Full Page Intro -->
  </section>

  <!--<div class="container my-5">
    <div class="p-5 pl-0">
      <a href="#" routerLink="forgot-password">Forgot</a>
    </div>
  </div>-->
